import React, { useState, useEffect } from 'react';
import { collectionsAPI } from '../services/api';
// ...existing code...
import './ManagementPages.css';

const CollectionsPage = () => {
  const [collections, setCollections] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [dateFilter, setDateFilter] = useState('');
  const [stats, setStats] = useState(null);

  useEffect(() => {
    fetchCollections();
  }, [dateFilter]);

  const fetchCollections = async () => {
    try {
      setLoading(true);
      setError(null);
      const params = dateFilter ? { startDate: dateFilter, endDate: dateFilter } : {};
      const response = await collectionsAPI.getSummary(params);
      // Handle both paginated response and direct array
      const data = response && (response.data || response) || [];
      const arr = Array.isArray(data) ? data : [];
      setCollections(arr);
    } catch (err) {
      setError(err.message || 'Failed to load collections');
      setCollections([]);
    } finally {
      setLoading(false);
    }
  };

  const getStats = () => {
    if (!Array.isArray(collections) || collections.length === 0) return null;
    
    const totalAmount = collections.reduce((sum, col) => sum + (col.total_collected || 0), 0);
    const totalCollections = collections.reduce((sum, col) => sum + (col.collection_count || 0), 0);
    const totalLoans = collections.reduce((sum, col) => sum + (col.loans_collected || 0), 0);
    const avgAmount = totalCollections > 0 ? totalAmount / totalCollections : 0;
    
    return {
      totalAmount,
      totalCollections,
      totalLoans,
      avgAmount,
    };
  };

  const displayStats = getStats();

  return (
    <div className="page-container">
      <div className="page-header">
        <h1>Collections Management</h1>
        <p>Track and manage loan collections and payments</p>
      </div>

      {/* Stats Cards */}
      {displayStats && (
        <div
          className="grid grid-3 stats-grid"
          style={{
            marginBottom: '20px',
            display: 'grid',
            gridTemplateColumns: 'repeat(3, 1fr)',
            gap: '18px',
          }}
        >
          <div className="dashboard-card">
            <div className="card-icon">💰</div>
            <div className="card-content">
              <div className="card-label">Total Collected</div>
              <div className="card-value">₹{displayStats.totalAmount.toLocaleString()}</div>
            </div>
          </div>
          <div className="dashboard-card">
            <div className="card-icon">📝</div>
            <div className="card-content">
              <div className="card-label">Collections</div>
              <div className="card-value">{displayStats.totalCollections}</div>
            </div>
          </div>
          <div className="dashboard-card">
            <div className="card-icon">📊</div>
            <div className="card-content">
              <div className="card-label">Average</div>
              <div className="card-value">₹{displayStats.avgAmount.toLocaleString(undefined, { maximumFractionDigits: 0 })}</div>
            </div>
          </div>
        </div>
      )}

      {/* Date Filter */}
      <div className="filters" style={{ marginBottom: '20px' }}>
        <input
          type="date"
          value={dateFilter}
          onChange={(e) => setDateFilter(e.target.value)}
          style={{
            padding: '8px 12px',
            borderRadius: '6px',
            border: '1px solid #ddd',
            fontSize: '14px',
          }}
        />
        {dateFilter && (
          <button
            className="filter-btn"
            onClick={() => setDateFilter('')}
          >
            Clear Filter
          </button>
        )}
      </div>

      {error && <div className="alert alert-error">{error}</div>}

      {loading ? (
        <div className="loader"></div>
      ) : collections.length > 0 ? (
        <div className="table-wrapper">
          <table className="table">
            <thead>
              <tr>
                <th>Date</th>
                <th>Collections Count</th>
                <th>Total Amount</th>
                <th>Loans Collected</th>
              </tr>
            </thead>
            <tbody>
              {collections.map((collection, idx) => (
                <tr key={idx}>
                  <td>{new Date(collection.date).toLocaleDateString()}</td>
                  <td>{collection.collection_count || 0}</td>
                  <td>₹{(collection.total_collected || 0).toLocaleString()}</td>
                  <td>{collection.loans_collected || 0}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      ) : (
        <div className="no-data">No collections found</div>
      )}
    </div>
  );
};

export default CollectionsPage;
